import "bootstrap/dist/css/bootstrap.min.css";

import React from "react";

import { GaLayout } from "../../components/page-releated/guia-amarela/layout";
import { GaForm } from "../../components/page-releated/guia-amarela/form";
import { GaHeader } from "../../components/page-releated/guia-amarela/header/ga";

export const GuiaAmarela: React.FC = () => {
    return (
        <GaLayout>
            <GaHeader />
            <GaForm />
        </GaLayout>
    );
};
